class marmetoProductCard extends HTMLElement {
    constructor() {
      super();
      let _this = this;
      this.productCard = this
      this.querySelectorAll(".product-card-swatch").forEach((swatch)=>{
        swatch.addEventListener('click', _this.onVariantChange.bind(this));
      })
    }
  
    onVariantChange(event) {
      this.renderProductCard(event);
    }
  
    async renderProductCard(event) {
      event.preventDefault();
        console.log(event.currentTarget)
      this.productSwatch = event.currentTarget
      this.productUrl = this.productSwatch.getAttribute("data-url");
      let variantUrl = `${this.productUrl}?view=card`;
    
      try {
        // Fetch the data
        const response = await fetch(variantUrl);
        const responseText = await response.text();
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const responseCard = html.querySelector('marmeto-product-card');

        //Note: we are manual updating element one by one because the quick event listerner will get removed if we replace its html
        //update image
        this.productCard.querySelector(".product__media__holder").innerHTML = responseCard.querySelector(".product__media__holder").innerHTML;
        //update badge
        this.productCard.querySelector(".product-badge").innerHTML = responseCard.querySelector(".product-badge").innerHTML;

        //update price
        this.productCard.querySelector(".product-grid-item__price").innerHTML = responseCard.querySelector(".product-grid-item__price").innerHTML;
       
        //quick-buy
        this.responseProductUrl = responseCard.querySelector(".btn-quick-buy").getAttribute("href");
        this.responseProductHandle = responseCard.querySelector(".btn-quick-buy").getAttribute("data-handle");
        this.productCard.querySelector(".btn-quick-buy").setAttribute("href", this.responseProductUrl);
        this.productCard.querySelector(".btn-quick-buy").setAttribute("data-handle", this.responseProductHandle);
        

        
    
        // this.productCard.innerHTML = responseCard.innerHTML; 
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    }
  
  }
  
  customElements.define('marmeto-product-card', marmetoProductCard);